var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('router-link',{staticClass:"question-mark-button",attrs:{"to":_vm.$routerHelper.withPlatformAndLang(_vm.$route, 'tickets', _vm.$i18n.locale)},nativeOn:{"click":function($event){return _vm.onAskQuestionClick()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }